import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/services/apiClient";
import { queryKeys } from "@/services/queryClient";
import type { PlayerCreatePayload, PlayerOut, PlayerSummary } from "@/services/types";

export function usePlayers() {
  return useQuery<PlayerSummary[]>({
    queryKey: queryKeys.players,
    queryFn: () => api.get("/players"),
  });
}

export function usePlayer(id: number | undefined) {
  return useQuery<PlayerOut>({
    queryKey: id ? queryKeys.player(id) : ["players", "disabled"],
    queryFn: () => api.get(`/players/${id!}`),
    enabled: id !== undefined,
  });
}

export function useCreatePlayer() {
  const qc = useQueryClient();
  return useMutation<PlayerOut, Error, PlayerCreatePayload>({
    mutationFn: (payload) => api.post("/players", payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.players });
    },
  });
}

export function useAbandonPlayer() {
  const qc = useQueryClient();
  return useMutation<void, Error, number>({
    mutationFn: (id) => api.delete(`/players/${id}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.players });
    },
  });
}
